import { Store } from 'vuex';
import axios from 'axios';
import Router from 'vue-router';
import i18n from '@/common/locale';
import { Environment } from '@/environments/environment';
import { Http } from '../http/http';
import { Util } from '../util/util';
import FingerprintJS2 from "fingerprintjs2";

/**
 * 拦截器
 *
 * @export
 * @class Interceptors
 */
export class Interceptors {

    /**
     * 路由对象
     *
     * @private
     * @type {(Router | any)}
     * @memberof Interceptors
     */
    private router: Router | any;

    /**
     * 缓存对象
     *
     * @private
     * @type {(Store<any> | any)}
     * @memberof Interceptors
     */
    private store: Store<any> | any;

    /**
     *  单列对象
     *
     * @private
     * @static
     * @type {LoadAppData}
     * @memberof Interceptors
     */
    private static readonly instance: Interceptors = new Interceptors();

    /**
     * Creates an instance of Interceptors.
     * 私有构造，拒绝通过 new 创建对象
     *
     * @memberof Interceptors
     */
    private constructor() {
        if (Interceptors.instance) {
            return Interceptors.instance;
        } else {
            this.intercept();
        }
    }

    /**
     * 获取 LoadAppData 单例对象
     *
     * @static
     * @param {Router} route
     * @param {Store<any>} store
     * @returns {Interceptors}
     * @memberof Interceptors
     */
    public static getInstance(route: Router, store: Store<any>): Interceptors {
        this.instance.router = route;
        this.instance.store = store;
        return this.instance;
    }

    /**
     * 拦截器实现接口
     *
     * @private
     * @memberof Interceptors
     */
    private intercept(): void {
        axios.interceptors.request.use((config: any) => {
            let appdata: any ;
            if (this.router) {
                appdata = this.store.getters.getAppData();
            }
            if (appdata && appdata.context) {
                config.headers['srforgsectorid'] = appdata.context.srforgsectorid;
            }
            if(!sessionStorage.getItem('token')){
                let arr;
                let reg = new RegExp("(^| )sysuaa-token=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg)){
                    sessionStorage.setItem('token',unescape(arr[2]));
                }
            }
            if (sessionStorage.getItem('token')) {
                const token = sessionStorage.getItem('token');
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            let fingerprint : string | null = ``;
            if (window.sessionStorage.getItem("Fingerprint")){
                fingerprint = window.sessionStorage.getItem("Fingerprint");
            } else {
                let options = {
                    excludes: {
                        language: true,
                        colorDepth: true,
                        deviceMemory: true,
                        pixelRatio: true,
                        availableScreenResolution: true,
                        timezoneOffset: true,
                        timezone: true,
                        sessionStorage: false,
                        localStorage: false,
                        indexedDb: false,
                        addBehavior: true,
                        openDatabase: false,
                        cpuClass: true,
                        doNotTrack: true,
                        plugins: true,
                        canvas: true,
                        webglVendorAndRenderer: true,
                        adBlock: true,
                        hasLiedLanguages: true,
                        hasLiedResolution: true,
                        hasLiedOs: true,
                        hasLiedBrowser: true,
                        touchSupport: true,
                        audio: false,
                        enumerateDevices: true,
                        hardwareConcurrency: true,
                    },
                };
                FingerprintJS2.get(options, function (components: any[]) {
                    const values = components.map((component: any) => component.value); // 配置的值的数组
                    const murmur = FingerprintJS2.x64hash128(values.join(''), 31); // 生成浏览器指纹
                    console.log(components);
                    console.log(values);
                    console.log(murmur);
                    sessionStorage.setItem("Fingerprint", murmur)
                })
            }
            // config.headers['Fingerprint'] = fingerprint;
            config.headers['Fingerprint'] = sessionStorage.getItem("Fingerprint");
            config.headers['Accept-Language'] =  i18n.locale;
            if (!Object.is(Environment.BaseUrl,"") && !config.url.startsWith('https://') && !config.url.startsWith('http://') && !config.url.startsWith('./assets')) {
                config.url = Environment.BaseUrl + config.url;
            }
            return config;
        }, (error: any) => {
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response: any) => {
            if(response.headers && response.headers['refreshtoken'] && sessionStorage.getItem('token')){
                this.refreshToken(response);
            }
            return response;
        }, (error: any) => {
            error = error ? error : { response: {} };
            let { response: res } = error;
            let { data: _data } = res;
            // 处理异常
            if(res.headers && res.headers['x-sys-error']){
                res.data.errorKey = res.headers['x-sys-error'];
            }
            if(res.headers && res.headers['x-sys-params']){
                res.data.entityName = res.headers['x-sys-params'];
            }
            if (res.status === 401) {
                this.doNoLogin(_data.data);
            }
            if(res.status === 403){
                if(res.data && res.data.status && Object.is(res.data.status,"FORBIDDEN")){
                    let alertMessage:string ="非常抱歉，您无权操作此数据，如需操作请联系管理员！";
                    Object.assign(res.data,{localizedMessage:alertMessage,message:alertMessage});
                }
            }
            // if (res.status === 404) {
            //     this.router.push({ path: '/404' });
            // } else if (res.status === 500) {
            //     this.router.push({ path: '/500' });
            // }

            return Promise.reject(res);
        });
    }

    /**
     * 处理未登录异常情况
     *
     * @private
     * @param {*} [data={}]
     * @memberof Interceptors
     */
    private doNoLogin(data: any = {}): void {
        // 清除user、token和cookie
        if(localStorage.getItem('user')){
            localStorage.removeItem('user');
        }
        if(sessionStorage.getItem('token')){
            this.logErrorLogout();
            sessionStorage.removeItem('token');
        }
        let leftTime = new Date();
        leftTime.setTime(leftTime.getSeconds() - 1);
        document.cookie = "sysuaa-token=;expires=" + leftTime.toUTCString();
        if (data.loginurl && !Object.is(data.loginurl, '') && data.originurl && !Object.is(data.originurl, '')) {
            let _url = encodeURIComponent(encodeURIComponent(window.location.href));
            let loginurl: string = data.loginurl;
            const originurl: string = data.originurl;

            if (originurl.indexOf('?') === -1) {
                _url = `${encodeURIComponent('?RU=')}${_url}`;
            } else {
                _url = `${encodeURIComponent('&RU=')}${_url}`;
            }
            loginurl = `${loginurl}${_url}`;

            window.location.href = loginurl;
        } else {
            if (Object.is(this.router.currentRoute.name, 'login')) {
                return;
            }
            this.router.push({ name: 'login', query: { redirect: this.router.currentRoute.fullPath } });
        }
    }

    private logErrorLogout():void{
        Http.getInstance().post('/runtimeapi/tokenLog/insertTokenLog?optionType=error_out','',false).then((res: any) => {
            console.log(res);
        })
    }

    /**
     * 刷新token
     *
     * @private
     * @param {*} [data={}]
     * @memberof Interceptors
     */
    private refreshToken(data:any = {}):void{
        if(data && data.config && (data.config.url == "/uaa/refreshToken")){
            return;
        }
        Http.getInstance().post('/runtimeapi/uaa/refreshToken',sessionStorage.getItem('token'),false).then((response: any) => {
            if (response && response.status === 200) {
                const data = response.data;
                if (data ) {
                    sessionStorage.setItem('token', data);
                    // Util.setCookie('sysuaa-token',data,0);
                    document.cookie = 'sysuaa-token' + "=" + escape(data) + ';path=/';
                }
            }else{
                console.log("刷新token出错");
            }
        }).catch((error: any) => {
            console.log("刷新token出错");
        });
    }

}
